import apiClient from './apiClient';

export const settingsApi = {
  // Alle Einstellungen abrufen
  getAll: async () => {
    const response = await apiClient.get('/einstellungen');
    return response.data;
  },

  // Einzelne Einstellung abrufen
  get: async (schluessel) => {
    const response = await apiClient.get(`/einstellungen/${schluessel}`);
    return response.data;
  },

  // Einzelne Einstellung speichern
  update: async (schluessel, wert) => {
    const response = await apiClient.put(`/einstellungen/${schluessel}`, { wert });
    return response.data;
  },

  // Mehrere Einstellungen speichern
  updateBulk: async (settings) => {
    const response = await apiClient.post('/einstellungen/bulk', settings);
    return response.data;
  },

  // SMTP-Konfiguration abrufen (Passwort maskiert)
  getSmtpConfig: async () => {
    const response = await apiClient.get('/einstellungen/smtp/config');
    return response.data;
  },

  // SMTP-Verbindung testen
  testSmtpConnection: async () => {
    const response = await apiClient.post('/einstellungen/smtp/test');
    return response.data;
  },

  // E-Mail-Vorlagen abrufen
  getEmailTemplates: async (type = 'rechnung') => {
    const response = await apiClient.get(`/einstellungen/email/templates?type=${type}`);
    return response.data;
  },

  // IMAP-Verbindung testen
  testImapConnection: async () => {
    const response = await apiClient.post('/einstellungen/imap/test');
    return response.data;
  },

  // IMAP-Verbindung neu starten
  restartImapConnection: async () => {
    const response = await apiClient.post('/einstellungen/imap/restart');
    return response.data;
  },

  // IMAP-Status abrufen
  getImapStatus: async () => {
    const response = await apiClient.get('/einstellungen/imap/status');
    return response.data;
  }
};
